import {ChangeDetectionStrategy, Component, Injectable, Input, signal} from "@angular/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

@Injectable()
export class KortSamlingRegister {

    private kortsamling: KortKomponent[] = [];
    private venterPåScrollTil = false;

    /** id til det aktive kortet, null dersom ingen kort er aktive */
    aktivtKort = signal<string | null>(null);

    constructor() {
    }

    aktiverKort(id: string | null) {
        this.aktivtKort.set(id);
    }

    aktiverKortOgSkrollTil(id: string | null) {
        this.aktiverKort(id);
        if (erNil(id)) return;

        //dersom denne metoden blir kalt før det forespurte kortet er registrert
        //må vi vente til kortet blir registrert
        const registrertKort = this.finnKort(id);
        if (erNil(registrertKort)) this.venterPåScrollTil = true;
        else registrertKort.skrollTil();
    }

    registrerKort(kort: KortKomponent) {
        this.kortsamling.push(kort);

        //aktivering av dette kortet kan ha blitt forespurt før det ble registrert
        if (this.venterPåScrollTil && this.aktivtKort() === kort.id()) {
            kort.skrollTil();
            this.venterPåScrollTil = false;
        }
    }

    fjernKort(kort: KortKomponent) {
        const indeks = this.kortsamling.indexOf(kort);
        if (indeks < 0) return;
        this.kortsamling.splice(indeks, 1);
    }

    finnKort(id: string): KortKomponent | undefined {
        return this.kortsamling.find(kort => kort.id() === id);
    }
}

@Component({
    selector: 'kort-samling',
    template: '<ng-content/>',
    styleUrl: 'kort-samling.scss',
    providers: [KortSamlingRegister],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KortSamlingKomponent {

    constructor(public readonly kortSamlingRegister: KortSamlingRegister) {
    }

    @Input() set initieltAktivt(id: string | null) {
        this.kortSamlingRegister.aktiverKortOgSkrollTil(id);
    }
}
